import { CommonModule, Location } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbOffcanvasConfig, NgbOffcanvas, NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AcademicYearService } from '../../../../../core/services/academic-year.service';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { FamilyService } from '../../../../../core/services/family.service';
import { FileService } from '../../../../../core/services/file.service';
import { InscriptionFileService } from '../../../../../core/services/inscription-file.service';
import { InscriptionService } from '../../../../../core/services/inscription.service';
import { OldSchoolService } from '../../../../../core/services/old-school.service';
import { ParentService } from '../../../../../core/services/parent.service';
import { StudentAyClassroomService } from '../../../../../core/services/student-ay-classroom.service';
import { StudentService } from '../../../../../core/services/student.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { ConfigService } from '../../../../../core/utils/config-service';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { IgxStepComponent, IgxStepperModule } from 'igniteui-angular';

@Component({
    selector: 'app-inscription-detail',
    templateUrl: './inscription-detail.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxExtendedPdfViewerModule, IgxStepperModule],
    styleUrls: ['./inscription-detail.component.css']
})
export class InscriptionDetailComponent implements OnInit {
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  loading=false
  data:any
  user:any
  role:any
  insCode:any
  pdfViewLoader=false
  selected_data:any
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  is_active:any
  search_text=""
  constructor(
    private location:Location,
    private sacService:StudentAyClassroomService,
    private spinnerService:NgxSpinnerService,
    private familyService:FamilyService,
    private oldSchoolService:OldSchoolService,
    private studentService:StudentService,
    private insService:InscriptionService,
    private fileService:FileService,
    private router:Router,
    private activatedRoute:ActivatedRoute,
    private _sanitizationService: DomSanitizer,
    configOffCanvas: NgbOffcanvasConfig,
     private offcanvasService: NgbOffcanvas,
     private toastrService: ToastrService,
     private parentService:ParentService,
     private lsService:LocalStorageService,
     config: NgbModalConfig,
    private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      
    configOffCanvas.position = 'end';
		configOffCanvas.backdropClass = 'bg-dark';
		configOffCanvas.keyboard = false;
   }
  ngOnInit(): void {
   this.insCode=this.activatedRoute.snapshot.paramMap.get('code');
   this.user=this.lsService.get(GlobalName.userName)
   this.role=this.user.roles[0].name
   if (this.insCode== undefined) {
    this.router.navigate(['inscription-index'])

   } else {
    this.getData()
   }
  }

  getData(){
    this.spinnerService.show()
    this.insService.get(this.insCode).subscribe((res:any)=>{
      this.spinnerService.hide()

        this.data=res.data
        this.is_active=res.data?.student?.current_ay_classroom?.is_active
        this.selected_data=res.data?.student?.current_ay_classroom
        },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des inscriptions",err)

    })
  }
  getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.pdfViewLoader=true
    this.spinnerService.show()
    this.fileService.get({
      folder:folder,
      code:code,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des inscriptions",err)

    })
  }


  validate(){
    this.loading=true
    this.insService.setState(this.insCode, 1).subscribe((res:any)=>{
      this.getData()
      this.loading=true

      },
  (err:any)=>{
    this.loading=false
    AppErrorShow.showError("Gestion des inscriptions",err)

  })
  }

  open(content:any,el:any){
    this.selected_data=el
    this.modalService.open(content)
  }
  deleteFamily(id:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.familyService.delete(id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getData()
      },
    (err:any)=>{
      console.log(err)
        AppSweetAlert.simpleAlert("error","Infos Famille",err.error.message)
    })
  }
})
  }
  editFamily(form:any){
    this.loading=true

    this.familyService.update(this.selected_data.id,form.value).subscribe((res:any)=>{
      this.loading=false
      this.modalService.dismissAll()
      form.resetForm()
      this.toastrService.success(res.message)
      this.getData()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppSweetAlert.simpleAlert("error","Infos Famille",err.error.message)
    })
  }
  deleteSchool(id:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.oldSchoolService.delete(id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getData()
      },
    (err:any)=>{
      console.log(err)
        AppSweetAlert.simpleAlert("error","Infos Famille",err.error.message)
    })
  }
})
  }
  editSchool(form:any){
    this.loading=true

    this.oldSchoolService.update(this.selected_data.id,form.value).subscribe((res:any)=>{
      this.loading=false
      this.modalService.dismissAll()
      form.resetForm()
      this.toastrService.success(res.message)
      this.getData()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppSweetAlert.simpleAlert("error","Infos établissement",err.error.message)
    })
  }
  editStudent(form:any){
    this.loading=true

    this.studentService.update(this.selected_data.id,form.value).subscribe((res:any)=>{
      this.loading=false
      this.modalService.dismissAll()
      form.resetForm()
      this.toastrService.success(res.message)
      this.getData()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppSweetAlert.simpleAlert("error","Infos établissement",err.error.message)
    })
  }
  editParent(form:any){
    this.loading=true

    this.parentService.update(this.selected_data.id,form.value).subscribe((res:any)=>{
      this.loading=false
      this.modalService.dismissAll()
      form.resetForm()
      this.toastrService.success(res.message)
      this.getData()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppSweetAlert.simpleAlert("error","Infos établissement",err.error.message)
    })
  }

  setStatus(value:any){
    this.loading=true

    this.toastrService.warning("Opération en cours")
  
        this.sacService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.loading=false

          this.location.back()
      },
      (err:any)=>{
        this.loading=false

        console.log(err)
          AppErrorShow.showError("Gestion des inscriptions",err)

      })
  }

}
